import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Badge, Button, Modal } from "react-bootstrap";
import HtmlParser, { domToReact } from "html-react-parser";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { get } from "../../utils/DeApi";

import Loader from "../Loader/Loader";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import CatalogueAdd from "../Catalogue/CatalogueAdd/CatalogueAdd";
import CatalogueRemove from "../Catalogue/CatalogueRemove/CatalogueRemove";

class PreviewFiling extends Component {
  constructor(props) {
    super(props);
    this.state = { doc: props.doc };
    this.subscribedPromises = [];
  }

  componentDidMount() {
    this.fetchDocument();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.doc.documentUrl !== this.props.doc.documentUrl) {
      this.setState({ doc: this.props.doc }, this.fetchDocument());
    }
  }

  fetchDocument() {
    this.setState({ error: null, isLoading: true });
    const { doc } = this.state;
    const { filing } = this.props;
    const client = process.env.REACT_APP_DOC_URL;

    let documentUrl =
      client +
      filing.filedAt.split("T").shift() +
      "/" +
      filing.accessionNo +
      "/" +
      doc.documentUrl.split("/").pop();

    axios
      .get(documentUrl)
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.fetchDocumentLegacy();
      });
  }

  fetchDocumentLegacy() {
    this.setState({ docContents: null, error: null, isLoading: true });
    const { doc } = this.state;
    const { filing } = this.props;

    const fetchDocumentPromise = get(`filings/${filing.accessionNo}/document`, {
      params: { type: doc.type.trim() },
    });

    fetchDocumentPromise.promise
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
  }

  parseHTML(html) {
    const { filing } = this.props;
    const options = {
      replace: ({ name, children, attribs }) => {
        if (name === "font") {
          return (
            <font style={{ fontSize: 12 }}>
              {domToReact(children, options)}
            </font>
          );
        }

        if (name === "a") {
          return (
            <a
              href={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.href}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {domToReact(children, options)}
            </a>
          );
        }

        if (name === "img") {
          return (
            <img
              alt={attribs.alt || filing.accessionNo}
              src={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.src}`}
            />
          );
        }
      },
    };

    try {
      return ReactDOMServer.renderToString(HtmlParser(html, options));
    } catch (e) {
      return html;
    }
  }

  render() {
    const { doc, docContents, isLoading, error } = this.state;

    return (
      <div className="scrollControl responsive-width">
        {isLoading && <Loader />}
        {error && <ErrorHandler error={error} />}
        {docContents && (
          <div dangerouslySetInnerHTML={{ __html: docContents }} />
        )}
      </div>
    );
  }

  renderCataloging() {
    const { filing, selections, onCatalogueAdd, onCatalogueRemove } =
      this.props;

    const { doc } = this.state;
    var catalogued = selections.find(
      (item) =>
        item.filingId === filing.accessionNo &&
        item.formType === doc.type &&
        doc.documentId === item.documentId
    );

    if (catalogued) {
      return (
        <CatalogueRemove
          catalogued={catalogued}
          onFilingRemoved={onCatalogueRemove}
        />
      );
    }
    return (
      <CatalogueAdd doc={doc} filing={filing} onFilingAdded={onCatalogueAdd} />
    );
  }
}

PreviewFiling.propTypes = {
  doc: PropTypes.object.isRequired,
  filing: PropTypes.object.isRequired,
  catalogue: PropTypes.array.isRequired,
  selections: PropTypes.array.isRequired,
  onCatalogueAdd: PropTypes.func,
  onCatalogueRemove: PropTypes.func,
};

export default PreviewFiling;
